export const LAWYERED_ROUTE = "/lawyered";
export const LAWYERED_CHALLAN_ROUTE = "/lawyered/challan";
